import { GROUP_ROLE_TO_STRING, ORG_ROLE_TO_STRING } from "Constants";
import { Member } from "Types";

export const transformRoleLabel = (
  member: Member,
  groupId?: string,
): string => {
  if (!groupId) return ORG_ROLE_TO_STRING[member.org_role];

  const currentGroup = member.org_groups.find(
    (group) => group.group_id === groupId,
  );

  if (currentGroup) {
    return GROUP_ROLE_TO_STRING[currentGroup.role];
  } else return "";
};
